import { render, staticRenderFns } from "./OpenPage.vue?vue&type=template&id=cda57944"
import script from "./OpenPage.vue?vue&type=script&lang=js"
export * from "./OpenPage.vue?vue&type=script&lang=js"
import style0 from "./OpenPage.vue?vue&type=style&index=0&id=cda57944&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports